import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const LeasingProtokolEdit = lazy(() =>
  import('@/modules/leasing/LeasingProtokolEdit').then((m) => ({
    default: m.LeasingProtokolEdit,
  })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/leasing/$id/protokol/upravit',
  component: () => (
    <Suspense fallback={null}>
      <LeasingProtokolEdit />
    </Suspense>
  ),
});
